// extracted by mini-css-extract-plugin
export default {"crumb-wrap":"breadCrumb_crumb-wrap__ldfHG","crumb-item":"breadCrumb_crumb-item__Ad1ca","crumb-label":"breadCrumb_crumb-label__DgV1Y","crumb-link":"breadCrumb_crumb-link__7kMU6"};